import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ApolloProvider } from "@apollo/react-hooks";
import { graphQLClient } from "./Config/graphQL";
import rootReducer from "./store/reducers/rootReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { createStore, applyMiddleware, compose } from "redux";

export const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : (f) => f
  )
);
// const userInput = prompt("Please Enter PHNX Beta Password");
// if (userInput == process.env.REACT_APP_PASSWORD) {
ReactDOM.render(
  <ApolloProvider client={graphQLClient}>
    <Provider store={store}>
      <App />
      <ToastContainer className="toastCustomStyle" />
    </Provider>
  </ApolloProvider>,
  document.getElementById("root")
);
// }
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
